
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreement/agreement",
      function () {
        return require("private-next-pages/agreement/agreement.js");
      }
    ]);
  